import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// 导入翻译文件
import enTranslation from './locales/en/translation.json';
import zhTranslation from './locales/zh/translation.json';
import enSoul from './locales/en/soul.json';
import zhSoul from './locales/zh/soul.json';
import enHeader from './locales/en/header.json';
import zhHeader from './locales/zh/header.json';
import enFooter from './locales/en/footer.json';
import zhFooter from './locales/zh/footer.json';

const resources = {
  en: {
    translation: enTranslation,
    soul: enSoul,
    header: enHeader,
    footer: enFooter,
  },
  zh: {
    translation: zhTranslation,
    soul: zhSoul,
    header: zhHeader,
    footer: zhFooter,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n; 